import { computed, Signal } from '@angular/core';
import { challenge as ChallengeGen } from '@valvur/shared-grpc';
import { toCamelCase } from '../../../../../../shared/helpers/string.helper';

export type RowType = 'field-label' | 'badge';
export type BadgeColor = 'grey' | 'green';

export interface CourseInfoRow {
  id: string;
  type: RowType;
  labelKey: string;
  value: string | number | null | undefined;
  badgeColor?: BadgeColor;
  customClass?: string;
  isSpecial?: boolean; // For special cases like tags
}

/**
 * Creates translation keys for course settings
 */
export function createTranslationKey(
  setting: string | undefined,
  prefix: string
): string {
  if (!setting) return '';
  const camelCased = toCamelCase(setting);
  return `${prefix}.${camelCased}`;
}

/**
 * Generates course information rows from a course
 */
export function createCourseInfoRows(
  course: () => ChallengeGen.Course | undefined
): CourseInfoRow[] {
  const courseData = course();
  if (!courseData) return [];

    const disciplineKey = createTranslationKey(
      courseData.settings?.discipline,
      'app.components.courseCreator.settings.mainInfo.discipline.options'
    );

    const audienceKey = createTranslationKey(
      courseData.settings?.audience,
      'app.components.courseCreator.settings.mainInfo.audience.options'
    );

    const toneKey = createTranslationKey(
      courseData.settings?.tone,
      'app.components.courseCreator.settings.mainInfo.tone.options'
    );

    return [
      {
        id: 'courseName',
        type: 'field-label',
        labelKey: 'app.components.courseCreator.publish.name',
        value: courseData.courseName,
      },
      {
        id: 'discipline',
        type: 'field-label',
        labelKey: 'app.components.courseCreator.publish.discipline',
        value: disciplineKey,
      },
      {
        id: 'tags',
        type: 'field-label',
        labelKey: 'app.components.courseCreator.publish.tags',
        value: null,
        customClass: 'course-publish__row--tags',
        isSpecial: true,
      },
      {
        id: 'audience',
        type: 'field-label',
        labelKey: 'app.components.courseCreator.publish.audience',
        value: audienceKey,
      },
      {
        id: 'tone',
        type: 'field-label',
        labelKey: 'app.components.courseCreator.publish.tone',
        value: toneKey,
      },
      {
        id: 'lessons',
        type: 'badge',
        labelKey: 'app.components.courseCreator.publish.lessons',
        value: courseData.tasks?.length,
        badgeColor: 'grey',
      },
      {
        id: 'duration',
        type: 'badge',
        labelKey: 'app.components.courseCreator.publish.duration',
        value: courseData.estimatedDuration,
        badgeColor: 'green',
      },
    ];
}

